import { useStore } from "@nanostores/react";
import type { ProductBundle } from "@wbly/data-storefront";
import {
  bundles as $bundles,
  relevantBundle,
} from "../../../pages/[locale]/cart/stores/bundles.store";
import { Bundle } from "./components/Bundle";
import styles from "./Bundles.module.css";

type BundlesProps = {
  bundles: ProductBundle[] | null;
  marketplace: string;
};

const { list } = styles;

export function Bundles({ bundles, marketplace }: BundlesProps) {
  /**
   * We want to keep non-UI logic (like finding a relevant bundle) in our stores.
   *
   * It looks a bit long-winded to set the bundles here, retrieve them in the store, then return the relevant one,
   * but this was the best approach I could find.
   */
  $bundles.set(bundles);
  const $relevantBundle = useStore(relevantBundle);

  if (!$relevantBundle) {
    return null;
  }

  return (
    <section className={list}>
      <Bundle
        key={$relevantBundle.id}
        marketplace={marketplace}
        {...$relevantBundle}
      />
    </section>
  );
}
